// src/components/ProveedorForm.jsx
import React, { useEffect } from "react";
import { Modal, Form, Button, Input } from "antd";

const ProveedorForm = ({ visible, onCancel, onSubmit, form, isEditing }) => {
  // 2️⃣ (Opcional) cuando cierras el modal, reiniciamos el form
  useEffect(() => {
    if (!visible) {
      form.resetFields();
    }
  }, [visible, form]);

  return (
    <Modal
      open={visible}
      title={isEditing ? "Editar Proveedor" : "Agregar Proveedor"}
      okText={isEditing ? "Actualizar" : "Crear"}
      cancelText="Cancelar"
      onCancel={onCancel}
      onOk={() => form.submit()}
      footer={false}
      destroyOnClose
    >
      <Form form={form} layout="vertical" onFinish={onSubmit}>
        <Form.Item
          name="nombre"
          label="Nombre"
          rules={[{ required: true, message: "Ingrese el nombre" }]}
        >
          <Input />
        </Form.Item>

        <Form.Item name="identificacion" label="Identificación">
          <Input />
        </Form.Item>

        <Form.Item name="direccion" label="Dirección">
          <Input />
        </Form.Item>

        <Form.Item
          name="correo"
          label="Correo electrónico"
          rules={[
            {
              type: "email",
              message: "Ingrese un correo válido",
            },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="telefono"
          label="Teléfono"
          rules={[{ required: true, message: "Ingrese el teléfono" }]}
        >
          <Input />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit">
            Guardar
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ProveedorForm;
